import LevelSelector from '../molecules/LevelSelector';
import MoveStudentDialog from './MoveStudentDialog';
import PageHeader from '../molecules/PageHeader';
import {
  getNumberOfStudentsInSession,
  getUnassignedStudents,
} from '../../helper';
import SessionContainer from '../molecules/SessionContainer';
import { Link } from 'react-router-dom';
import DelimitedList from '../atoms/DelimitedList/DelimitedList';
import { MenuItem, Menu, Snackbar } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SacramentConfirmation from './SacramentConfirmation';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { getAdminInfo } from '../../helper';

const ClassesLayout = ({
  pageLevelTitle,
  pageMsg,
  sessions,
  students,
  sessionSpread,
  openMoveStudentDialog,
  closeMoveStudentDialog,
  openSacramentDialog,
  closeSacramentDialog,
  sacramentOpen,
  selectedStudent,
  moveStudentOpen,
  setRemoteTrigger,
  levelSelection,
  setSacramentType,
  sacramentType,
  updateSacraments,
  snackBarOpen,
  snackBarClose,
}) => {
  const navigate = useNavigate();

  // ACTION MENU HANDLERS
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const closeMenu = () => {
    setAnchorEl(null);
  };

  // ACTION MENU ITEMS
  const gotoNominalRoll = () => {
    navigate('/manage/classes/' + levelSelection + '/nominalroll');
  };
  const openSacrament = type => {
    setSacramentType(type);
    openSacramentDialog();
    closeMenu();
  };

  // GET UNASSIGNED STUDENTS
  const unassigned = getUnassignedStudents(students);
  const unassignedList = unassigned.map(student => {
    return (
      <Link onClick={() => openMoveStudentDialog(student)}>
        {student.student_first_name} {student.student_last_name}
      </Link>
    );
  });

  const admin = getAdminInfo();

  return (
    <div>
      <div className='grid-cols-2 items-center sm:grid'>
        {/* Not using PageHeader RightSideComponent prop because it messes up the MUI popup menu */}
        <div className=''>
          <PageHeader testid='page-title'>Classes</PageHeader>
        </div>
        {Number(admin['admin_level']) === 9 && (
          <div className='mb-4 text-center sm:text-right'>
            {levelSelection && (
              <span
                id='basic-button'
                aria-controls={openMenu ? 'basic-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={handleClick}
                className='cursor-pointer text-lg font-bold text-primary-700'
              >
                Actions
              </span>
            )}

            <Menu
              id='basic-menu'
              anchorEl={anchorEl}
              open={openMenu}
              onClose={closeMenu}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
                'data-cy': 'basic-menu',
              }}
            >
              {levelSelection === '2' && (
                <div>
                  {/* <MenuItem onClick={() => openSacrament('baptism')}>
                  Baptism
                </MenuItem> */}
                  <MenuItem
                    onClick={() => openSacrament('recon')}
                    id='first-recon-button'
                  >
                    First Reconciliation
                  </MenuItem>
                </div>
              )}

              {levelSelection === '3' && (
                <MenuItem
                  onClick={() => openSacrament('comm')}
                  id='holy-comm-button'
                >
                  Holy Communion
                </MenuItem>
              )}

              <MenuItem onClick={gotoNominalRoll} id='nominal-roll-button'>
                Nominal Roll
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>

      <div className='center mx-auto my-4 w-full border sm:w-1/2 md:w-1/3'>
        <LevelSelector />
      </div>
      <div>
        {unassignedList.length > 0 && (
          <div className='my-4 font-bold'>
            The following students are unassigned:
          </div>
        )}

        <DelimitedList listItems={unassignedList} delimiter='comma' />
      </div>
      <div className='my-5 text-2xl font-medium' data-cy='page-level-title'>
        {pageLevelTitle}
      </div>
      {!students && <div>{pageMsg}</div>}
      <div
        className='grid justify-center gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5'
        data-cy='session-container'
      >
        {students &&
          sessions.map(session => {
            let sessionCount = 0;
            const numStudentsInSession = getNumberOfStudentsInSession(
              session.id,
              sessionSpread
            );
            return (
              <SessionContainer
                key={session.id}
                session={session}
                numStudentsInSession={numStudentsInSession}
                students={students}
                sessionCount={sessionCount}
                handleClickOpen={openMoveStudentDialog}
              />
            );
          })}
      </div>
      <MoveStudentDialog
        onClose={closeMoveStudentDialog}
        student={selectedStudent}
        open={moveStudentOpen}
        sessions={sessions}
        setRemoteTrigger={setRemoteTrigger}
      />

      <SacramentConfirmation
        onClose={closeSacramentDialog}
        open={sacramentOpen}
        sacramentType={sacramentType}
        updateSacraments={updateSacraments}
      />

      <Snackbar
        open={snackBarOpen}
        message='Sacrament Updated!'
        autoHideDuration={6000}
        onClose={snackBarClose}
        id='snackbar'
      >
        <div
          className={`flex items-center justify-between rounded-md bg-green-700 p-2 text-white`}
        >
          <CheckCircleOutlineIcon />
          <span className='mx-2'>
            Sacrament information updated successfully!
          </span>

          <IconButton
            size='small'
            aria-label='close'
            color='inherit'
            onClick={snackBarClose}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        </div>
      </Snackbar>
    </div>
  );
};

export default ClassesLayout;
